module.exports = __webpack_public_path__ + "static/img/logo@2xyg.2f672592.png";